import { Injectable }      from '@angular/core';
import { Role }             from '../models/role';
import { Http, Headers }   from '@angular/http';
import { AngularFireAuth } from 'angularfire2/auth';
import { Observable }      from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/map';

@Injectable()
export class RoleService {

  private rolesURL = 'https://us-central1-softmart-beef5.cloudfunctions.net/app/roles';
  private headers = new Headers({'Content-Type':'application/json'});

  constructor(private http: Http, private af: AngularFireAuth) {}

  getRoles(): Observable<Role[]> {
    return this.af.authState.flatMap(user => !user ?
      Observable.of([]) :
      Observable.fromPromise(<Promise<any>>user.getIdToken()).flatMap(idToken => {
        return this
          .http
          .get(this.rolesURL, { headers: new Headers({'Authorization': `Bearer ${idToken}`}) })
          .map(response => response.json().filter(role => !role.disabled) as Role[])
      })
    );
  }

  getRole(id: string): Observable<Role> {
    return this.af.authState.flatMap(user => !user ?
      Observable.of(null) :
      Observable.fromPromise(<Promise<any>>user.getIdToken()).flatMap(idToken => {
        return this
            .http
            .get(`${this.rolesURL}/${id}`, { headers: new Headers({'Authorization': `Bearer ${idToken}`}) })
            .map(response => response.json() as Role)
      })
    );
  }

  create(role: Role): Observable<Role> {
    return this.af.authState.flatMap(user => !user ?
      Observable.of(null) :
      Observable.fromPromise(<Promise<any>>user.getIdToken()).flatMap(idToken => {
        return this.http.post(
        this.rolesURL,
        JSON.stringify(role),
          {
            headers: new Headers({
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${idToken}`
            })
          }
        ).map(res => res.json() as Role);
      })
    );
  }

  update(role: Role): Observable<Role> {
    return this.af.authState.flatMap(user => !user ?
      Observable.of(null) :
      Observable.fromPromise(<Promise<any>>user.getIdToken()).flatMap(idToken => {
        return this.http.put(
        `${this.rolesURL}/${role.id}`,
        JSON.stringify(role),
          {
            headers: new Headers({
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${idToken}`
            })
          }
        ).map(res => res.json() as Role);
      })
    );
  }

  delete(role: Role)  {
      return this.af.authState.flatMap(user => !user ?
        Observable.of(null) :
        Observable.fromPromise(<Promise<any>>user.getIdToken()).flatMap(idToken => {
          return this.http.delete(
          `${this.rolesURL}/${role.id}`,
            {
              headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${idToken}`
              })
            }
          )
        })
      );
  }

}



// WEBPACK FOOTER //
// ./src/app/users/services/role.service.ts